import React, { PropsWithChildren } from "react";
import styles from "./Webhook.module.css";

function Wrapper({ children }: PropsWithChildren) {
  return <div className={styles.main}>{children}</div>;
}

export default Wrapper;
